export default "__VITE_ASSET__85c1ff80__"